import React from 'react';
import { Truck, Info, CheckCircle } from 'lucide-react';

const ShippingInfo = () => {
  return (
    <div className="mb-4 sm:mb-6 rounded-lg border border-blue-300 bg-blue-100">
      <div className="p-3 sm:p-4">
        <div className="flex items-start gap-2 sm:gap-3">
          <div className="mt-0.5 sm:mt-1 shrink-0">
            <Truck className="h-4 w-4 sm:h-5 sm:w-5 text-blue-600" />
          </div>
          <div className="space-y-1.5 sm:space-y-2">
            <h4 className="text-sm sm:text-base font-medium text-blue-600">
              Shipping Information
            </h4>
            <div className="space-y-2 text-xs sm:text-sm text-blue-500">
              <div className="space-y-1">
                <p className="font-medium">Step 1: Complete Your Purchase</p>
                <ul className="ml-3 sm:ml-4 list-disc space-y-0.5 sm:space-y-1">
                  <li>Proceed with payment for your selected items</li>
                  <li>You'll receive an order confirmation page after successful payment</li>
                </ul>
              </div>
              
              <div className="space-y-1">
                <p className="font-medium">Step 2: Get Your Shipping Quote</p>
                <ul className="ml-3 sm:ml-4 list-disc space-y-0.5 sm:space-y-1">
                  <li>Click the "Get Shipping Quote" button on your order confirmation page</li>
                  <li>We'll calculate your shipping fee based on your location and order details</li>
                  <li>You'll receive the shipping quote via WhatsApp within 1-2 hours</li>
                </ul>
              </div>

              <div className="bg-white bg-opacity-50 rounded-lg p-2 sm:p-3">
                <div className="flex items-start gap-1.5 sm:gap-2">
                  <CheckCircle className="h-4 w-4 sm:h-4 sm:w-4 mt-0.5 text-orange-600" />
                  <p className="text-[11px] sm:text-xs text-orange-600">
                    Shipping fees are separate from your order total and will be paid upon delivery. This ensures you get the most accurate and fair shipping rates based on your location.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShippingInfo;